import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

interface OfferService {
  Name: string; // The name or title of the visa service
  RecordId: number; // Unique identifier for the visa record
  amount: number; // Amount or cost associated with the service
  imgAlt: string | null; // Alternative text for the image, can be null
  imgUrl: string; // URL for the image
  options: string; // Comma-separated string of option IDs
  slugURL: string; // Slug for the URL path
}

const baseUrl = import.meta.env.VITE_API_URL;

const BottomLeftSidebar = () => {
  const [offer, setOffer] = useState<OfferService>();

  const fetchSideCardData = async () =>
    {
      try {

        const response = await fetch(`${baseUrl}/api/openRoute/specialOffers`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });
        const data = await response.json();
        if (data) {
          setOffer(data.offer);
        }
      } catch (error) {
        console.error("Error fetching order data:", error);
      }
    };

  useEffect(() => {
    const login_info = localStorage.getItem("Login_info");
    if (login_info) {
      fetchSideCardData();
    }
  }, []);

  return (
    <>
      <div className="inneroffer card mb-3">
        <div className="card-body">
          <h5 className="card-title">Today's Offers</h5>
          <div className="offer-card position-relative bg-primary">
            <div className="badge-2">
              <span>Offer</span>
            </div>
            <div className="offerText text-white ">
              <h4 className="offer-name">{offer?.Name}</h4>
              <p className="offer-p text-white">
                <span>{offer?.amount.toFixed(2)}</span> AED
              </p>

              <Link
                to={`/${offer?.slugURL}`}
                className="tourist-card-btn text-decoration-none"
              >
                View More
              </Link>
            </div>
            <div className="d-flex align-items-center flex-wrap">
              <img
                loading="lazy"
                src={offer?.imgUrl}
                className="img-fluid"
                alt={offer?.imgAlt ?? offer?.Name}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BottomLeftSidebar;
